import type { ReactNode } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { fadeRise, VIEWPORT } from "./motion";

interface RevealProps {
  children: ReactNode;
  className?: string;
}

/**
 * Scroll-reveal wrapper for a single marketing block (design.md §12). Fades and
 * rises its content into view once, using the shared motion vocabulary. Honors
 * `prefers-reduced-motion` by rendering the content in place with no animation
 * (Framer Motion's transforms aren't covered by the global CSS reduce rule, so
 * the guard is explicit).
 */
export function Reveal({ children, className }: RevealProps) {
  const reduced = useReducedMotion();
  if (reduced) {
    return <div className={className}>{children}</div>;
  }
  return (
    <motion.div
      className={className}
      variants={fadeRise}
      initial="hidden"
      whileInView="visible"
      viewport={VIEWPORT}
    >
      {children}
    </motion.div>
  );
}
